import { GameManager } from "../Managers/GameManager";
import { ModuleManager } from "../Managers/ModuleManager";
import { Communication } from "neo-games";
import { GameModuleBaseResponse } from "neo-games/Engine/Communication/Game/Responses/GameModuleBaseResponse";
import { GameModuleResponse } from "neo-games/Engine/Communication/Game/Responses/GameModuleResponse";

export class Settings {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    public static readonly SymbolTeasing: number = 11;
    public static readonly SymbolMystery: number = 12;
    public static readonly SymbolSpecial: number = 13;
    public static readonly SymbolWild: number = 14;
    public static readonly SymbolsHitDuration: Object = { 11: 20, 12: 20, 13: 20 };
    public static readonly SymbolsNoTrim: Array<number> = [11, 12, 13];

    public static readonly CustomDataSpecialSymbolName: string = "collectedSpecialSymbol";
    public static readonly CustomDataLevelName: string = "level";
    public static readonly CustomDataRoundTotalWin: string = "roundTotalWin";

    public static CurrentCoinsCollectorCount: number = 0;
    public static RespinNumber: number = 0;

    // inidicates respin scene until in response
    public static isRespin(): boolean {
        let value = false;
        if (ModuleManager.freespinsActive()) {
            value =
                GameManager.freespinsResponse != null &&
                GameManager.freespinsResponse.respin != null &&
                GameManager.freespinsResponse.respin !== 0;
        } else {
            value =
                GameManager.baseResponse != null &&
                GameManager.baseResponse.respin != null &&
                GameManager.baseResponse.respin !== 0;
        }
        return value;
    }

    public static getCustomDataCoins(): number {
        if (
            GameManager.freespinsResponse.customData != null &&
            GameManager.freespinsResponse.customData[Settings.CustomDataSpecialSymbolName] != null &&
            GameManager.freespinsResponse.customData[Settings.CustomDataSpecialSymbolName] >= 0
        ) {
            return GameManager.freespinsResponse.customData[Settings.CustomDataSpecialSymbolName];
        } else {
            return -1;
        }
    }

    public static getCustomDataLevel(): number {
        if (
            GameManager.freespinsResponse.customData != null &&
            GameManager.freespinsResponse.customData[Settings.CustomDataLevelName] != null &&
            GameManager.freespinsResponse.customData[Settings.CustomDataLevelName] > 0
        ) {
            return GameManager.freespinsResponse.customData[Settings.CustomDataLevelName];
        } else {
            return 1; // default level 1
        }
    }

    public static isNewCoins(): boolean {
        let dataCoins: number = Settings.getCustomDataCoins();

        if (dataCoins >= 0 && Settings.CurrentCoinsCollectorCount != dataCoins) {
            return true;
        }

        return false;
    }

    public static getNewCoins(): number {
        let dataCoins: number = Settings.getCustomDataCoins();

        if (dataCoins >= 0 && Settings.CurrentCoinsCollectorCount != dataCoins) {
            if (Settings.CurrentCoinsCollectorCount > dataCoins) {
                return dataCoins;
            } else {
                return dataCoins - Settings.CurrentCoinsCollectorCount;
            }
        }

        return 0;
    }

    public static remainingFreespinsCount(): number {
        if (
            GameManager.freespinsResponse != null &&
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null
        ) {
            return GameManager.freespinsResponse.freeSpins.remainingCount;
        }

        return 0;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Settings.ts
 **/